export default "__VITE_ASSET__wPKrz_te__"